import { ErrorMessage, Field, Formik, useFormik, Form } from "formik";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CANCEL, SAVE, TERM_REASON } from "../../../shared/constants/Constants";

const TermReasonForm = ({ termReason, submit, cancel }) => {
    const validate = (values) => {
        const errors = {};
        if (!values.term_reason) {
            errors.term_reason = "Required";
        }
        return errors;
    };

    return (
        <Formik
            initialValues={{
                id: termReason?.id ?? null,
                term_reason: termReason?.term_reason ?? "",
            }}
            validate={validate}
            onSubmit={submit}
            enableReinitialize
        >
            {() => (
                <Form className="row g-4">
                    <div className="col-md-6">
                        <label htmlFor="name" className="form-label">
                            {TERM_REASON}<span className="error-text">*</span>
                        </label>
                        <Field
                            className="form-control"
                            type="text"
                            name="term_reason"
                            placeholder="Term Reason"
                            autoComplete="off"
                        />
                        <span className="error-text">
                            <ErrorMessage name="term_reason" />
                        </span>
                    </div>
                    <div className="col-md-12">
                        <DefaultButton
                            buttonClass={"btn btn-secondary me-2"}
                            buttonTitle={CANCEL}
                            actionBlock={cancel}
                        />
                        <DefaultButton
                            buttonClass={"default-btn-color"}
                            buttonTitle={SAVE}
                            buttonType={"submit"}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default TermReasonForm;
